import { TextInput } from '@/components/form/TextInput.tsx';
import { TextareaInput } from '@/components/form/TextareaInput.tsx';
import { useFormContext } from 'react-hook-form';
import { ClientInputFormWithCustomFields } from '@/features/public/booking/schemas/clientSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import CheckboxInput from '@/components/form/CheckboxInput.tsx';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import { DropdownCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import { LongTextCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/LongTextCustomFieldDefinitionDto.ts';
import { CardTitle } from '@/components/ui/Card.tsx';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';

interface ParticipantCustomFieldsFormProps {
  index: number;
  participantForm: CustomFieldDefinitionDto[];
}

const ParticipantCustomFieldsForm = ({
  index,
  participantForm,
}: ParticipantCustomFieldsFormProps) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ClientInputFormWithCustomFields>();

  if (!participantForm || participantForm.length === 0) {
    return null;
  }

  return (
    <>
      <CardTitle className="pt-2">Informacje o uczestniku</CardTitle>
      {participantForm.map((field) => {
        const inputRegister = register(
          `participants.${index}.customFields.${field.id}`,
        );
        const inputError =
          errors.participants?.[index]?.customFields?.[field.id]?.message;
        switch (field.type) {
          case FieldType.TEXT: {
            return (
              <TextInput
                key={field.id}
                label={field.name}
                register={inputRegister}
                required={field.required}
                placeholder={field.placeholder ?? ''}
                error={inputError}
                hint={field.hint}
              />
            );
          }
          case FieldType.LONG_TEXT: {
            const longTextField = field as LongTextCustomFieldDefinitionDto;
            return (
              <TextareaInput
                key={field.id}
                label={field.name}
                register={inputRegister}
                required={field.required}
                placeholder={field.placeholder ?? ''}
                hint={field.hint}
                error={inputError}
                rows={longTextField.defaultHeight ?? 3}
              />
            );
          }
          case FieldType.CHECKBOX: {
            return (
              <CheckboxInput
                key={field.id}
                label={field.name}
                register={inputRegister}
                required={field.required}
                error={inputError}
                hint={field.hint}
              />
            );
          }
          case FieldType.DROPDOWN: {
            const dropdownField = field as DropdownCustomFieldDefinitionDto;
            const optoins = dropdownField.options.map((option) => ({
              label: option.label,
              value: option.id ?? option.label,
            }));
            return (
              <SingleSelectInput
                label={field.name}
                fieldName={`participants.${index}.customFields.${field.id}`}
                control={control}
                placeholder={field.placeholder ?? ''}
                options={optoins}
                hint={field.hint}
                required={field.required}
                error={inputError}
                isClearable={field.required === false}
              />
            );
          }
          default:
            return null;
        }
      })}
    </>
  );
};

export default ParticipantCustomFieldsForm;
